/**
 * Localized string map helpers for CMS property definitions.
 */
import { CONTENT_LOCALES, LOCALE_LABELS } from "../constants";

export function localizedStringProperties(markdown = false) {
  return Object.fromEntries(
    CONTENT_LOCALES.map((locale) => [
      locale,
      {
        name: LOCALE_LABELS[locale],
        dataType: "string" as const,
        ...(markdown ? { markdown: true } : {}),
      },
    ]),
  );
}

/** Empty en/de/fr/it map for seed defaults. */
export function emptyLocaleMap(fill = ""): Record<string, string> {
  return Object.fromEntries(CONTENT_LOCALES.map((locale) => [locale, fill]));
}

export function localeMapFromEn(en: string, others?: Partial<Record<string, string>>): Record<string, string> {
  return {
    en,
    de: others?.de ?? en,
    fr: others?.fr ?? en,
    it: others?.it ?? en,
  };
}
